import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

function CallDurationChart({ data }) {
  if (!data || data.length === 0) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        height: '100%', color: 'var(--text-muted)', fontSize: '14px'
      }}>No duration data available</div>
    );
  }

  const formatted = data.map(item => ({
    ...item,
    hourLabel: `${String(item.hour).padStart(2, '0')}:00`
  }));

  return (
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart data={formatted} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
        <defs>
          <linearGradient id="durationGradient" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#0a72e7" stopOpacity={0.3}/>
            <stop offset="95%" stopColor="#0a72e7" stopOpacity={0}/>
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6" />
        <XAxis dataKey="hourLabel" tick={{ fontSize: 12, fill: '#6b7280' }} axisLine={{ stroke: '#e5e7eb' }} />
        <YAxis tick={{ fontSize: 12, fill: '#6b7280' }} axisLine={{ stroke: '#e5e7eb' }} />
        <Tooltip contentStyle={{
          background: 'white', border: '1px solid var(--border)',
          borderRadius: 'var(--radius-sm)', boxShadow: 'var(--shadow-md)', fontSize: '13px'
        }} formatter={(value) => [`${value} min`, 'Duration']} labelFormatter={(label) => `Hour: ${label}`} />
        <Area type="monotone" dataKey="total_duration_minutes" stroke="#0a72e7" strokeWidth={2} fill="url(#durationGradient)" />
      </AreaChart>
    </ResponsiveContainer>
  );
}

export default CallDurationChart;
